/**
 * {{FN_DOC}} / {{FN_FOLDER}} / {{FN_SKILL}} markers are chip storage.
 * User-visible assistant copy must never show the raw address.
 */

function markerTitle(encId: string, encTitle: string): string {
  try {
    const title = encTitle ? decodeURIComponent(encTitle) : decodeURIComponent(encId)
    return title.trim()
  } catch {
    return ''
  }
}

export function hideRawFlowNoteMarkers(text: string): string {
  if (!text || !text.includes('{{FN_')) return text
  const titled = text.replace(
    /\{\{FN_(?:DOC|FOLDER|SKILL):([^|}]*)\|([^}|]*)(?:\|[^}]*)?\}\}/g,
    (_match, encId: string, encTitle: string) => markerTitle(encId, encTitle),
  )
  const stripped = titled
    .replace(/\{\{FN_(?:DOC|FOLDER|SKILL):[^}\n]*/g, '')
    .replace(/[ \t]{2,}/g, ' ')
    .replace(/\n{3,}/g, '\n\n')
    .trim()
  if (/^Working on:\s*\.{0,3}$/i.test(stripped)) return 'Working on it...'
  return stripped
}
